// $('.main_slider').slick({
//     dots: true,
//     infinite: true,
//     autoplay: false,
//     autoplaySpeed: 3000,
//     slidesToShow: 1,
//     slidesToScroll: 1,
//     arrows: true,
//     prevArrow: "<button class='prev_arrow'><img src='https://cdn.shopify.com/s/files/1/0629/2622/5635/files/67f26887adf5a978d97c2358a807c5dd.png?v=1645775372'></button>",
//     nextArrow: "<button class='next_arrow'><img src='https://cdn.shopify.com/s/files/1/0629/2622/5635/files/d0738deab2a5c1807fc072bb9f66e5c2.png?v=1645775398'></button>"
//   });

$('.main_slider').slick({
  dots: true,
  infinite: true,
  autoplay: true,
  autoplaySpeed: 3000,
  centerMode: true,
  centerPadding: '10%',
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: true,
  prevArrow: "<button class='prev_arrow'><img src='https://cdn.shopify.com/s/files/1/0629/2622/5635/files/67f26887adf5a978d97c2358a807c5dd.png?v=1645775372'></button>",
  nextArrow: "<button class='next_arrow'><img src='https://cdn.shopify.com/s/files/1/0629/2622/5635/files/d0738deab2a5c1807fc072bb9f66e5c2.png?v=1645775398'></button>",
  responsive: [
    {
      breakpoint: 1100,
      settings: {
        centerPadding: '0',
        slidesToShow: 1
      }
    },
  ]
});

//  Motorbike Slider
$('.motor_slider').slick({
  dots: false,
  infinite: true,
  arrows: false,
  autoplay: true,
  autoplaySpeed: 3000,
  slidesToShow: 1,
  slidesToScroll: 1,
});


$(document).ready(function() {
    $('.gahd_product_variant_main').click(function() {
        $('.gahd_product_variant_main').removeClass('active');
        $(this).addClass('active');
    });
});


$(document).ready(function(){
  $('span.gahd_label label').click(function () {
      var a = $(this).attr('data-img');
     console.log(a)
      $('.featured_img_product img').attr('src', a)
  });
});

$(document).ready(function(){
	$('ul.tabs li').click(function(){
		var tab_id = $(this).attr('data-tab');
		$('ul.tabs li').removeClass('current');
		$('.tab-content').removeClass('current');
      $('.tab-content').removeClass('first-1');
		$(this).addClass('current');
		$("#"+tab_id).addClass('current');
	});
});


$('.featured-cards .carousel').slick({
  infinite: true,
  slidesToShow: 3,
  slidesToScroll: 1,
  centerMode: true,
  centerPadding: '120px',
  responsive: [
    {
            breakpoint: 1024,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
               centerMode: true,
        centerPadding: '30px',
            }
        },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,
        centerPadding: '30px',
      },
    },
  ],
});

$('.product-cards-home .carousel').slick({
  infinite: true,
  slidesToShow: 3,
  slidesToScroll: 1,
  centerMode: true,
  centerPadding: '120px',
  responsive: [
    {
        breakpoint: 1024,
        settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        centerPadding: '30px',
            }
        },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        centerPadding: '30px',
      },
    },
  ],
});


$('.product-cards .carousel').each(function(key, item) {

  var sliderIdName = 'slider' + key;

  this.id = sliderIdName;

  var sliderId = '#' + sliderIdName;

var $status = $(this).parent('.product-cards').find('.pagingInfo');
var $slickElement = $(this);
var numOfSlides = 0;

$slickElement.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
  //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
  if(!slick.$dots){
  	return;
  }
  
  var i = (currentSlide ? currentSlide : 0) + 1;
  $status.text(i + '/' + (slick.$dots[0].children.length));

  numOfSlides = slick.$dots[0].children.length;
  $(this).find('.slick-dots').attr('data-lenght', numOfSlides);
  
});


    var slidesShow = 3;
    var childElements = item.childElementCount;
    // Check if we can fulfill the preferred slidesToShow
    if( slidesShow > childElements ) {
        if( childElements == 1 ) {
          childElements = 2;
        }
        slidesShow = (childElements - 1);
    }
  console.log(slidesShow);

$(sliderId).slick({
	infinite: true,
	slidesToShow: slidesShow,
  autoplay: false,
  centerMode: true,
  dots: true,
  arrows: true,
  prevArrow: '<a href="javascript:void()"><svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M20 2L8 14.0003L20 26" stroke="#fff" stroke-width="2"/> </svg></a>',
  nextArrow: '<a href="javascript:void()"><svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M8 2L20 14.0003L8 26" stroke="#fff" stroke-width="2"/> </svg></a>',
  responsive: [
    {
            breakpoint: 1024,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
               centerMode: true,
        centerPadding: '30px',
            }
        },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: false,
        centerPadding: '30px',
      },
    },
  ],
});

});


